import accenture from '../../../assets/Accenture.png'
import cloudemployee from '../../../assets/CloudEmployee.jpg'
import analog from '../../../assets/Analog.png'

export const awards = [
    {
        title: 'Ace Employee Award',
        organization: 'Cloud Employee APAC',
        dates: 'December 2025',
        logo: cloudemployee
    },
    {
        title: 'Special Recognition: Icon Patriots',
        organization: 'Cloud Employee APAC',
        dates: 'December 2024',
        logo: cloudemployee
    },
    {
        title: 'Semi-Finalist, Innovate for Society',
        organization: 'Accenture',
        dates: 'August 2020',
        logo: accenture
    },
    {
        title: 'Spot Award',
        organization: 'Analog Devices, Inc.',
        dates: 'June 2019',
        logo: analog
    }
]